var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": "right",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "base.eightBitCode.eightBitCode"
                                        ),
                                        prop: "eightBitCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value:
                                            _vm.queryCondition.eightBitCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "eightBitCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.eightBitCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "base.eightBitCode.eightBitCodeName"
                                        ),
                                        prop: "eightBitCodeName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value:
                                            _vm.queryCondition.eightBitCodeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "eightBitCodeName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.eightBitCodeName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "工厂编号",
                                        prop: "plantNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.plantNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "plantNo",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "queryCondition.plantNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "工厂名称",
                                        prop: "plantName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.plantName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "plantName",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.plantName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "供应商编号",
                                                prop: "supplierCode",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .supplierCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "supplierCode",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.supplierCode",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "供应商名称",
                                                prop: "supplierName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .supplierName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "supplierName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.supplierName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "物料产品状态",
                                                prop: "status",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  table: "TM_MATERIAL",
                                                  field: "STATUS",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.status,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "status",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.status",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "提货点",
                                                prop: "pickupPoint",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .pickupPoint,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "pickupPoint",
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.pickupPoint",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "DC",
                                                prop: "dcName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.dcName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "dcName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.dcName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "温区",
                                                prop: "temperature",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  table: "COMMON",
                                                  field: "TEMPERATURE",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .temperature,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "temperature",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.temperature",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.restQueryForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.tableData,
                border: "",
                "max-height": "1610",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "eightBitCode",
                  sortable: "",
                  label: "8位码",
                  fixed: "",
                  "min-width": "90",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "a-link",
                            on: {
                              click: function ($event) {
                                return _vm.toDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.eightBitCode))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "180",
                  prop: "eightBitCodeName",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "8位码名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "90",
                  prop: "plantNo",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "工厂编号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  prop: "plantName",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "工厂名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  prop: "supplierCode",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "供应商编号",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "supplierName",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "供应商名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "statusI18n",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "物料产品状态",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  prop: "temperatureI18n",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "温区",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  prop: "sixBitCode",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "六位码",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "200",
                  prop: "sixBitCodeName",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "六位码名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "externalPackagingLength",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "外包装长(cm)",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "externalPackagingWidth",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "外包装宽(cm)",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "externalPackagingHeight",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "外包装高(cm)",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "130",
                  prop: "externalPackagingNetweight",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "外包装净重(kg)",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "130",
                  prop: "externalPackagingGrossweight",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "外包装毛重(kg)",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "120",
                  prop: "palletLayerNumber",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "每Pallet层数",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  prop: "palletLayerBoxNumber",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "每层箱数",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "80",
                  prop: "fiveBitCode",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "五位码",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "100",
                  prop: "fiveBitCodeName",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "五位码名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "160",
                  prop: "categoryLevel1Code",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "CategoryLevel1Code",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "170",
                  prop: "categoryLevel1Name",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "CategoryLevel1Name",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "160",
                  prop: "categoryLevel2Code",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "CategoryLevel2Code",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "170",
                  prop: "categoryLevel2Name",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "CategoryLevel2Name",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "160",
                  prop: "categoryLevel3Code",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "CategoryLevel3Code",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "170",
                  prop: "categoryLevel3Name",
                  "show-overflow-tooltip": "",
                  sortable: "",
                  label: "CategoryLevel3Name",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelDcDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelDcDialog = $event
            },
          },
        },
        [
          _c("SelDc", {
            ref: "selectDcRef",
            attrs: { multipleSelectionFlag: true },
            on: { subCallMethod: _vm.selectDcMethod },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }